import { api } from '../axiosClient';

export const deleteExpenseAttachment = async (
  attachmentUrl: string,
): Promise<void> => {
  return api.delete('/Expense/attachment', {
    data: attachmentUrl,
  });
};

export const deleteExpenseAttachmentWithId = async (
  attachmentUrl: string,
  expenseId: number,
): Promise<void> => {
  return api.delete(`/Expense/${expenseId}/attachment`, {
    data: attachmentUrl,
  });
};
